import { render, staticRenderFns } from "./tableEvalsHead.vue?vue&type=template&id=64b008d3&"
import script from "./tableEvalsHead.vue?vue&type=script&lang=js&"
export * from "./tableEvalsHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports